import React from "react";
import { useTranslation } from "react-i18next";

export default function PageNotFound() {
  const [t, i18n] = useTranslation("global");

  return (
    <div style={{ marginTop: "70px" }}>
      <h1>Page not found</h1>
      <p>Please try again</p>
      {/* <h1>{t("unauth.title")}</h1>
      <p>{t("unauth.text.detail")}</p> */}
    </div>
  );
}
